import styled from 'styled-components'

// LimitedTextInput component

const TextInput = ({
  id,
  label = 'Input',
  state,
  changeHandler,
  value,
  maxLength = 10,
  placeholder = 'Your text',
  disabled = false,
}) => {
  // console.log(state)

  const remaining = maxLength - value.length

  const handleChange = (e) => {
    changeHandler?.(e)
  }

  return (
    <Wrap>
      <Input
        id={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
      <Chars>{remaining} characters remaining</Chars>
    </Wrap>
  )
}

export default TextInput

const Wrap = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  text-align: center;
`
const Input = styled.input`
  text-align: center;
  padding: 10px;
  width: fit-content;
  font-size: 18px;
`
const Chars = styled.span`
  font-size: 12px;
  opacity: 0.6;
`
